import { ForgotPasswordView } from "../views/forgotPasswordView.jsx";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

function ForgotPassword() {
  async function handleForgotPassword(email) {
    const auth = getAuth();

    // Determine redirect URL (dev vs prod)
    const isLocalhost = window.location.hostname === "localhost";
    const actionCodeSettings = {
      url: isLocalhost
        ? "http://localhost:8080/#/login"
        : "https://stad-hunt.web.app/#/login", 
      handleCodeInApp: false,
    };

    try {
      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      alert("Reset link sent! Please check your email.");
    } catch (error) {
      console.error("Reset email error:", error);
      alert("Error: " + error.message);
    }
  }

  return <ForgotPasswordView onResetRequest={handleForgotPassword} />;
}

export { ForgotPassword };
